export const APP_ROUTES = {
  home: '/',
  tour: '/tour',
  tools: '/tools',
  learn: '/learn',
  charting: '/charting',
  process: '/process',
  documentTranslator: '/tools/document-translator',
  textTranslator: '/tools/text-translator',
  admin: '/admin',
};

export const SIDEBAR_RESET_STATE_KEY = 'sidebarResetAt';

export const buildSidebarResetState = () => ({
  [SIDEBAR_RESET_STATE_KEY]: Date.now(),
});

export const APP_SHELL_TABS = [
  {id: 'home', label: 'Home', route: APP_ROUTES.home},
  {id: 'charting', label: 'Review', route: APP_ROUTES.charting},
  {id: 'tools', label: 'Tools', route: APP_ROUTES.tools},
  {id: 'learn', label: 'Opalite University', route: APP_ROUTES.learn},
];

export const isAdminAppRoute = (pathname: any) =>
  pathname.startsWith(APP_ROUTES.admin) ||
  pathname.startsWith('/admin-dashboard') ||
  pathname.startsWith('/super-admin');

export const getAppShellActiveTab = (pathname: any) => {
  if (isAdminAppRoute(pathname)) return null;
  if (pathname.startsWith(APP_ROUTES.charting)) return 'charting';
  if (pathname.startsWith(APP_ROUTES.tools)) return 'tools';
  if (pathname.startsWith(APP_ROUTES.learn)) return 'learn';
  return 'home';
};

export const getAdminAppShellRoute = (role: any) =>
  role === 'superadmin' ? '/super-admin' : APP_ROUTES.admin;
